<app-infinite-select
  (searchChange)="filterUniversitiesSubject.next($event)"
  (scrollToEnd)="filterUniversitiesSubject.next($event)"
  (optionSelected)="onUniversitySelected($event)"
  [createdValue]="universitySelected"
  [options]="universities"
  [required]="true"
  optionTitle="nameFull"
  label="Universidade"
  [isUniversity]="true"
  [inputValue]="universitySelected?.nameFull"
  [disabledButton]="universitySelected !== null"
  [disabled]="!!universitySelected"
  [loading]="loading"
  placeholder="Pesquise pelo nome da universidade"
  [actionButton]="false"
  [showSuccessBackground]="true"
  data-testid="university-select"
>
</app-infinite-select>
